import React from "react";
import { Helmet } from "react-helmet";
import MainImage from "../../assets/MainImage.jpg";
import Footer from "../../components/Footer";
import SecondImage from "../../assets/AboutImage4.jpg";
import NavLite from "../../components/NavLite";
import PastWord from "../../components/PastWord";
import SmallTestimony from "../../components/SmallTestimony";

function Dallas() {
  return (
    <section>
      <Helmet>
        <title>Custom Web Design & SEO Services for Dallas Women Entrepreneurs | Her Growth Co.</title>
        <meta
          name="description"
          content="Her Growth Co helps Dallas-based female founders grow online with elegant websites and strategic SEO. Stand out, attract clients, and scale with confidence."
        />
        <meta
          name="keywords"
          content="dallas web design for women entrepreneurs, dallas seo for female-led businesses, custom websites for women in dallas, high-end branding and web design dallas, dallas digital marketing for consultants, premium seo for coaches dallas, all-in-one solution for women experts, authority web design dallas, dallas cro and conversion strategy, website design agency for women dallas, dallas female founder visibility strategy, seo expert for dallas women entrepreneurs, lead-generating websites dallas, dallas personal brand design services, dallas authority launchpad web services, premium content marketing dallas tx, website design for consultants dallas, dallas niche seo experts, growth-focused web services dallas, high-ticket client website dallas, brand visibility for dallas women, bespoke web development dallas, expert seo solutions for women dallas, web design for dallas thought leaders, digital strategy for women-led startups dallas, high-end website design texas, premium web design services, austin custom website development, conversion-focused web design, mobile responsive web design austin, website design for coaches, ux/ui website design austin, brand-first website design, premium branding website texas, website design for consultants, creative web design agency austin, bespoke web development texas, web design for personal brands austin, austin expert wordpress designer, strategic website design for leads, lead generation web design austin, custom web graphics austin, lightning-fast websites austin tx, mobile-first web design texas, expert website builder for women entrepreneurs, website design for experts texas, web designer for thought leaders, seo-ready website builds, visually engaging websites texas, ux design for female-led businesses"
        />
      </Helmet>

      {/* Hero Section */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <NavLite />
        <div className="p-10">
          <h2 className="text-3xl font-bold uppercase text-black mb-4 text-center">
            <span className="bg-[#CFF098] italic">
              Dallas Web Design & SEO for Women Entrepreneurs
            </span>
          </h2>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-10 md:py-10 flex flex-col items-center text-center">
        <p className="text-gray-200 mb-4 text-2xl max-w-2xl">
          Based in Dallas? We build websites and execute SEO strategies that help female entrepreneurs grow, thrive, and lead in their industries.
        </p>
        <a href="https://cal.com/woaomwebdesign/15min">
          <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
            BOOK A FREE STRATEGY CALL →
          </button>
        </a>
      </div>




      {/* Our Process */}
<div className="mx-auto w-full max-w-7xl flex flex-col items-center text-center mt-20">
  <h2 className="text-3xl font-medium md:text-4xl text-white uppercase">
    Our Process
  </h2>
</div>

{/* Centered Paragraph below heading */}
<p className="mx-auto mt-4 max-w-3xl text-sm text-gray-200 sm:text-base md:mb-12 lg:mb-16 text-center">
  We support Dallas women entrepreneurs with tailored web design and SEO strategies that fuel brand growth and client connection.
</p>

<div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12">
  {/* Text Section */}
  <div className="flex flex-col justify-center w-full md:w-1/2">
    {[
      {
        step: 1,
        title: "Strategy Session",
        desc: "We uncover your business goals and target audience to tailor a perfect website strategy.",
      },
      {
        step: 2,
        title: "Custom Design",
        desc: "Crafting an elegant, fully responsive website that captures your brand’s Dallas spirit.",
      },
      {
        step: 3,
        title: "Local SEO Focus",
        desc: "Implementing Dallas-specific SEO tactics to boost your visibility where it matters most.",
      },
      {
        step: 4,
        title: "Launch & Nurture",
        desc: "We launch your site and continue SEO support to help your Dallas business thrive online.",
      },
    ].map(({ step, title, desc }) => (
      <div key={step} className="mb-8 flex max-w-lg justify-center gap-4 px-6 py-5 text-black">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gray-100">
          <p className="text-sm font-bold sm:text-base">{step}</p>
        </div>
        <div className="ml-4 flex flex-col gap-2">
          <h5 className="text-xl font-medium uppercase text-white">{title}</h5>
          <p className="text-sm text-gray-200">{desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex items-stretch">
    <img
      alt="Website Design for Women Entrepreneurs Dallas"
      src={MainImage}
      className="w-full object-cover"
    />
  </div>
</div>





      {/* Past Work & Testimonials */}
      <PastWord />
      <SmallTestimony />

      {/* About Us Section */}
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
              Helping <span className="italic text-black bg-[#CFF098]">Dallas Women Entrepreneurs</span> Thrive with a <span className="italic text-black bg-[#CFF098]">Next-Level Online Presence</span>
            </h4>
            <p className="text-sm text-white sm:text-xl">
              We specialize in elegant websites and expert SEO for Dallas women-led businesses. Whether you're launching, scaling, or refining your online identity—we build your digital foundation.
              <br /><br />
              Our team understands the Dallas business landscape and how to elevate your brand so your clients see you as the clear choice.
            </p>
            <p className="mt-6 mb-6 text-xl italic uppercase">
              Ready to lead online with confidence? <span className="italic">We’ve got you.</span>
            </p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/about"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm"
              >
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="Dallas women entrepreneur using laptop"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}

export default Dallas;
